// import state from '../state'
import { q1O } from '../util/nE';
import Flickity from 'flickity';
import gsap from 'gsap';
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(SplitText);

class HorizontalCards {
  constructor(el) {
    this.el = el;
    this.title = this.el.querySelector('.horizontal-cards__title');
    this.cards = this.el.querySelectorAll('.horizontal-cards__item');
    this.list = this.el.querySelector('.horizontal-cards__list');
    this.btns = this.el.querySelectorAll('.horizontal-cards__nav-button');
    this.itemWrapper = this.el.querySelectorAll(
      '.horizontal-cards__item-wrapper',
    );
  }

  init() {
    this.buildSplitText();
    this.buildTimelineIn();
    this.buildFlickity();
  }

  buildFlickity() {
   
    this.flickity = new Flickity(this.list, {
      // wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      imagesLoaded: true,
      selectedAttraction: 0.03,
      friction: 0.4,
      draggable: false,
      // freeScroll: true,
      // setGallerySize: false,
      percentPosition: true,
      adaptiveHeight: false,
      cellAlign: 'left',
      contain: true,
      on: {
        ready: () => {
          this.itemWrapper.forEach((item) => {
            gsap.set(item, { height: '100%' });
          });
        },
      },
    });

    if (this.btns.length) {
      this.btns[0].addEventListener('click', () => {
        this.flickity.previous();
      });

      this.btns[1].addEventListener('click', () => {
        this.flickity.next();
      });
    }
   
  }

  buildSplitText() {
    if (!this.title) {
      return;
    }

    this.split = new SplitText(this.title, {
      type: 'chars, words, lines',
      linesClass: 's-line u-t overflow-hidden',
      // lineThreshold: 10,
    });
  }

  buildTimelineIn() {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
      },
      onComplete:()=> {
        this.split.revert()
      },
      defaults: {
        duration: 1.5,
        ease: (t) => {
          return q1O(t);
        },
      },
    });

    tl.set(this.el, { autoAlpha: 1 });

    if (this.title) {
      tl.fromTo(
        this.split.chars,
        {
          yPercent: 100,
          autoAlpha: 0,
        },
        {
          yPercent: 0,
          autoAlpha: 1,
          stagger: 0.021,
        },
        0,
      );
    }

    tl.fromTo(
      this.cards,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        stagger: 0.05,
      },
      0,
    );
  }
}

export default HorizontalCards;



//////////////////
// WEBPACK FOOTER
// ./scripts/components/HorizontalCards.js
// module id = 50
// module chunks = 0